import script from "./ClassStudentStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassStudentStatistics.vue?vue&type=script&setup=true&lang=js"

import "./ClassStudentStatistics.vue?vue&type=style&index=0&id=1757101a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1757101a"]])

export default __exports__